import React   from 'react';
import Spinner from './spinner';

const NewImageThumbnailSpinner = () => {
  return (
    <div className="loading-spinner">
      <Spinner mini={true}/>
    </div>
  );
}

export default NewImageThumbnailSpinner;
